
import { ImapService } from "./imap.service";

import Map from 'ol/Map';
import { BehaviorSubject, Subject } from "rxjs";
import Select from 'ol/interaction/Select';
import Feature from 'ol/Feature';
import { Injectable } from '@angular/core';
import { AwgLayers, FeatureMap } from "../../../model/layer.model";

@Injectable()
export abstract class MapAbstractService implements ImapService {
    
    layers: AwgLayers [];


    map :Map;
    widgetsActive:Array<string>=[];

    selectionMode = false;
    selectInteractions:Array<Select>=[];

    private _clickMapSource = new BehaviorSubject<any>(0);
    private _clickMapfeature = new BehaviorSubject<any>(0);
    
    clickMap$ = this._clickMapSource.asObservable()
    clickFeatureMap$ = this._clickMapfeature.asObservable()

    constructor(){
        this.createMap();   
    }

    public meteoActive = new Subject<any>();
    meteoActive$ = this.meteoActive.asObservable();

    abstract removeAllLayers();
    abstract createMap();
    abstract aggiungiVector(name:string,features:any);
    abstract aggiungiPoligono(name:string,coordinate: any);
    abstract createCircleStyle(fillColor: string, strokeColor: string);
    abstract fillStyleList(valueColor: string[]);
    abstract setStyleToLayer(layerName: string, style?:any);
    abstract createVectorSource(geoJSON: any, dataProjection?:string,featureProjection?:string) ;
    abstract createVectorLayer(vectorSource: any, name: string, zIndex: number, style: any, selectable?: boolean, opacity?:number) 
    abstract createTileXYZSource(url: any, options:any)
    abstract createBingSource(key:string, imagerySet:string, options:any)
    abstract createTileLayer(tileSource: any, name: string, zIndex: number, extent?:number[],opacity?:string);
    abstract createImageLayer(imageSource: any, name: string, zIndex: number, extent?:number[],opacity?:string);    
    abstract setStyle(layerName: string, category: string, values: string[]);
    abstract addLayerGeoJson(layerName: string, geoJSON: any,  color?: string);
    abstract removeLayer(layerName: string);
    abstract removeLayerStartsWith(layerName: string);
    abstract setZoom(zoom: Number);
    abstract addVectorLayerIfNotExist(layerName: string, geoJSON: any, zIndex: number, style?: any, selectable?: boolean);
    abstract addTileXYZIfNotExist(layerName: string, url: any, zIndex: number, options?:any, key?:string, imagerySet?:string)
    abstract toggleVisibleLayer(layerName: string, visible: boolean);
    abstract getLayerByName(layerName: string):any;

    abstract addLayers(layers:Array<any>);
    abstract createOverlay(idTagElement:string, positioning:string, offset:number[]);
    abstract updatePositionOverlay(cordinate:Array<number>);
    abstract convertToEpsg(epsgFrom:string, epsgTo:string, coords:any);
    abstract createSourceTileWMS(url: string, params: any, serverType: string, projection: string, cors: string);
    abstract createSourceImageWMS(url: string, params: any, serverType: string, projection: string, cors: string);
    abstract addTileWMSIfNotExist(layerName: string, element: AwgLayers);
    abstract addImageWMSIfNotExist(layerName: string, element: AwgLayers);
    abstract setOpacity(value: string,name:string);
    abstract createPolygonStyle(fillColor:string, strokeColor:string, width?:number);

    abstract addVectorLayerToMap(layer:any);




    abstract setInitView(extent?:any, lon?: string, lat?: string, initViewToCoordinate?: boolean);

    abstract setZoomBing();
    
    abstract getLayerAtPoint(event: any);

    abstract setPropertiesToLayer(layerName: string, properties: any []);

    abstract removeLayersByProperty(propertyName:string, propertyValue:string);
    
    abstract getMapResolution();

    abstract getMapBbox(epsgFrom:string,epsgTo:string);


    abstract getProjFromCode(codice:string);

    abstract selectLayer(layerIn: any);


    abstract layerStyleJson(feature:any);

    abstract updateParamstoAllWMS(objs: any[]);

    abstract getWMSLayersWithECQLOrTK();

    abstract   getMeteoAttivo();
    
    //abstract callFilter(filter: any);
    
    activeWidget(widgetKey:string){
        this.widgetsActive.push(widgetKey);
    }

    onClickMap(e:any){
        this._clickMapSource.next({data:e, widgets:this.widgetsActive});
    }

    onSelectedFeature(e:any){
        this._clickMapfeature.next({data:e, widgets:this.widgetsActive});
    }

    enableSelectionMode(){
        this.selectionMode=true;
    }

    disableSelectionMode(){
        this.selectionMode=false;
    }

    getAllSelectedFeature():Array<Feature>{
        let features:Array<Feature>=[];
        this.selectInteractions.forEach(select=>{
            features.push(select.getFeatures());
        });
        return features;
    }
    setMeteoActive(e:boolean){
        this.meteoActive.next();
    }
}
